import { ReactNode } from "react";

import { StepMenuItem } from "@/components/Interface/Stepper/StepMenu";
import { CardContainer } from "@/components/Layout/BaseLayouts/CardContainer";
import { StepFlowStepper } from "@/components/Layout/BaseLayouts/StepFlowLayout/StepFlowStepper";

export interface StepFlowLayoutProps {
  dataTestid?: string;
  title: string;
  step: number;
  totalSteps: number;
  stepLabel: string;
  description?: string;
  headerAction?: ReactNode;
  menuItems: StepMenuItem[];
  menuToggleLabel: string;
  children: ReactNode;
}

export const StepFlowLayout = ({
  dataTestid,
  title,
  step,
  totalSteps,
  stepLabel,
  description,
  headerAction,
  menuItems,
  menuToggleLabel,
  children,
}: StepFlowLayoutProps) => (
  <section className="w-full" data-testid={dataTestid}>
    <CardContainer
      className="flex w-full flex-col gap-6 rounded-lg p-6"
      variant="ivory"
    >
      {headerAction}

      <div className="flex w-full flex-col gap-4">
        <h1 className="text-headline-xl font-semibold leading-xs tracking-[-0.02em] text-foreground-primary">
          {title}
        </h1>
        <StepFlowStepper
          step={step}
          totalSteps={totalSteps}
          stepLabel={stepLabel}
          description={description}
          menuItems={menuItems}
          menuToggleLabel={menuToggleLabel}
        />
      </div>

      {children}
    </CardContainer>
  </section>
);
